<section class="main-content">
  <div class="section-body">
    @if (accountingInfo) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="card card-cm-dashboard w-100">
            <div class="card-header">
              <div class="row">
                <div class="col-12">
                  <h4 class="text-primary">Accounting Dashboard - Billing Activity</h4>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-9">
                </div>
                <div class="col-3">
                  <!-- <tui-input-date-range [formControl]="startDateSelection" tuiTextfieldSize="m">
                    Start - End Date
                    <input placeholder="From - To" tuiTextfieldLegacy />
                  </tui-input-date-range> -->
                  <tui-textfield tuiTextfieldSize="m">
                        <label tuiLabel>Start - End Date</label>

                        <input
                            tuiInputDateRange
                            [formControl]="startDateSelection"
                            placeholder="From - To" />

                        <tui-calendar-range *tuiDropdown />
                    </tui-textfield>
                  <div class="row mt-1">
                    <div class="col-12 text-center">
                      <b>Effective Date:</b> <span class="primary-color"> {{startDate |
                      date : DAY_NAME_MONTH_DAY_YEAR}} to {{endDate | date :
                    DAY_NAME_MONTH_DAY_YEAR}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Total Jobs </div>
                  <div class="card-body text-center">
                    @if (accountingInfo.totalJobCount > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('TOT')"
                        >
                      {{accountingInfo.totalJobCount}} </h4>
                    }
                    @if (accountingInfo.totalJobCount <= 0) {
                      <h4 class="text-secondary">
                      {{accountingInfo.totalJobCount}} </h4>
                    }
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary  lh-11 primary-color">Invoiced Jobs </div>
                  <div class="card-body text-center">
                    @if (accountingInfo.totalInvoicedJobCount > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('IN')"
                        >
                      {{accountingInfo.totalInvoicedJobCount}} </h4>
                    }
                    @if (accountingInfo.totalInvoicedJobCount <= 0) {
                      <h4 class="text-secondary">
                      {{accountingInfo.totalInvoicedJobCount}} </h4>
                    }
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary  lh-11 primary-color">Outstanding Jobs</div>
                  <div class="card-body text-center">
                    @if (accountingInfo.totalOutstandingJobCount > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('OUT')"
                        >
                      {{accountingInfo.totalOutstandingJobCount}} </h4>
                    }
                    @if (accountingInfo.totalOutstandingJobCount <= 0) {
                      <h4 class="text-secondary">
                      {{accountingInfo.totalOutstandingJobCount}} </h4>
                    }
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Billing Not Submitted
                  </div>
                  <div class="card-body text-center">
                    @if (getBillingNotSubmted(accountingInfo.totalBillNotSubmittedCompanyJobCount, accountingInfo.totalSubcontractorJobCount) > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('BL')"
                        >
                        {{getBillingNotSubmted(accountingInfo.totalBillNotSubmittedCompanyJobCount,
                      accountingInfo.totalSubcontractorJobCount)}} </h4>
                    }
                    @if (getBillingNotSubmted(accountingInfo.totalBillNotSubmittedCompanyJobCount, accountingInfo.totalSubcontractorJobCount) <= 0) {
                      <h4 class="text-secondary"
                        >
                        {{getBillingNotSubmted(accountingInfo.totalBillNotSubmittedCompanyJobCount,
                      accountingInfo.totalSubcontractorJobCount)}} </h4>
                    }
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Subcontractor Jobs</div>
                  <div class="card-body text-center">
                    @if (accountingInfo.totalSubcontractorJobCount > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('SUB')"
                        >
                      {{accountingInfo.totalSubcontractorJobCount}} </h4>
                    }
                    @if (accountingInfo.totalSubcontractorJobCount <= 0) {
                      <h4 class="text-secondary"
                        >
                      {{accountingInfo.totalSubcontractorJobCount}} </h4>
                    }
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="card w-100">
                  <div class="card-header text-secondary lh-11 primary-color">Hybrid Jobs</div>
                  <div class="card-body text-center">
                    @if (accountingInfo.totalHybridJobCount > 0) {
                      <h4 class="text-secondary text-decoration-underline primary-color cursor-pointer"
                        (click)="getDashboardSOList('HY')"
                        >
                      {{accountingInfo.totalHybridJobCount}} </h4>
                    }
                    @if (accountingInfo.totalHybridJobCount <= 0) {
                      <h4 class="text-secondary">
                      {{accountingInfo.totalHybridJobCount}} </h4>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <div class="card text-center">
                  <div class="card-header">
                    <h5 class="text-center-m-0-auto text-primary p-2">Quick Links</h5>
                  </div>
                  <div class="card-body p-4">
                    <div class="row">
                      @if (getBillingEntryReportAccess()) {
                        <div class="col-3">
                          <div (click)="goToBillingEntryReport()" class="card cursor-pointer">
                            <div class="card-body p-2 text-primary">
                              Billing Entry Report
                            </div>
                          </div>
                        </div>
                      }
                      @if (getPayrollEntryReportAccess()) {
                        <div class="col-3">
                          <div (click)="goToPayrollEntryReport()" class="card cursor-pointer">
                            <div class="card-body p-2 text-primary">
                              Payroll Entry Report
                            </div>
                          </div>
                        </div>
                      }
                      @if (getPayrollEntrySnapshotAccess()) {
                        <div class="col-3">
                          <div (click)="goToPayrollEntrySnapshot()" class="card cursor-pointer">
                            <div class="card-body p-2 text-primary">
                              Payroll Entry Snapshot
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
</section>

<ng-template [tuiDialogOptions]="{ closable: false, size: 'l', dismissible: false}" [(tuiDialog)]="isOpenSOListDialog">
  <tui-loader class="loader" [inheritColor]="isLoadingSOListDialog" [overlay]="isLoadingSOListDialog"
    [loading]="isLoadingSOListDialog">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
            <span class="mt-1 pad-left-10"> SO List</span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
            (click)="closeSOListDialog()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content">
      <hr class="title-line mt-1 mb-2">
      <div class="row">
        <div class="col-12 text-right mt-2">
          <div class="text-right quick-search">
            <!-- <tui-input tuiTextfieldSize="s" (ngModelChange)="checkIfClear($event)"
              (keyup)='filterDatatableShow($event)' [(ngModel)]="quickSearch"
              style="width:180px;margin-left: 12px;" tuiTextfieldIconLeft="@tui.search"
              class="input" [tuiTextfieldCleaner]="true">
              Quick Search
              <input placeholder="Quick Search" size="s" tuiTextfieldLegacy />
            </tui-input> -->
            <tui-textfield
              tuiTextfieldSize="s"
              [tuiTextfieldCleaner]="true"
              [iconStart]="'@tui.search'"
              class="input"
              style="width:180px; margin-left:12px;">
              <input
                  tuiInput
                  [(ngModel)]="quickSearch"
                  (ngModelChange)="checkIfClear($event)"
                  (keyup)="filterDatatableShow($event)"
                  placeholder="Quick Search" />
          </tui-textfield>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="table-responsive tableScroll mt-1" id="tableContainer">
            <ngx-datatable #ngxTable class="material table-md" [rows]="soList"
              [loadingIndicator]="isLoading" columnMode="force"
              [sorts]="[{prop: 'serviceOrderFullNumber', dir: 'asc'}]" [headerHeight]="60"
              rowHeight="auto" [footerHeight]="40" [rowHeight]="55" [scrollbarH]="scrollBarHorizontal"
              [limit]="currentPageLimit" [reorderable]="true" [messages]="{emptyMessage: 'No data available in table'}"
              [selectionType]="gridSelectionType">
              <ngx-datatable-column name="SO#" prop="serviceOrderFullNumber">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div [tuiHighlight]="quickSearch" [tuiHighlightColor]="GRID_HIGH_LIGHT_COLOR">
                  {{row.serviceOrderFullNumber}}</div>
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Show Name" prop="showName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div [tuiHighlight]="quickSearch" [tuiHighlightColor]="GRID_HIGH_LIGHT_COLOR">
                    {{row.showName}} @if (row.showTags) {
                    <span class="pad-left-5"
                    >({{row.showTags}})</span>
                  }
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Show Tags" prop="showTags">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.showTags}}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="City Manager Name" prop="cityManagerName">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{row.cityManagerName}}
              </ng-template>
            </ngx-datatable-column>
            @if (isOpenSubcontractorJob) {
              <ngx-datatable-column [sortable]="false" [width]="80"
                [maxWidth]="80" class="action-column">
                <ng-template let-column="column" ngx-datatable-header-template>
                  <div>Action</div>
                </ng-template>
                <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex"
                  ngx-datatable-cell-template>
                  @if (row.jobType === SUB_CONTRACTOR) {
                    <a
                      (click)="openClearSubcontractorJob(row.serviceOrderId)"
                      class="primary-color cursor-pointer text-decoration-underline">
                      Clear Count
                    </a>
                  }
                </ng-template>
              </ngx-datatable-column>
            }
            <ngx-datatable-footer>
              <ng-template ngx-datatable-footer-template let-rowCount="rowCount"
                let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage"
                let-offset="offset">
                <app-ngx-common-footer [page]="curPage" [size]="pageSize" [count]="rowCount"
                (currentPageLimits)="onLimitChange($event)"></app-ngx-common-footer>
                <app-datatable-pager [visiblePagesCount]="4" [page]="curPage" [size]="pageSize"
                  [count]="rowCount" [hidden]="false"
                (change)="ngxTable.onFooterPage($event)"></app-datatable-pager>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </div>
      </div>
    </div>
  </div>
</tui-loader>
</ng-template>

<ng-template [tuiDialogOptions]="{ closable: false, size: 'm', dismissible: false}" [(tuiDialog)]="isOpenClearSubcontractorJob">
  <tui-loader class="loader" [inheritColor]="isLoadingClearSubcontractorJob"
    [overlay]="isLoadingClearSubcontractorJob" [loading]="isLoadingClearSubcontractorJob">
    <header class="header">
      <div class="col-12">
        <div class="title-flex">
          <h4 class="main-title">
            <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
            <span class="mt-1 pad-left-10"> Clear Subcontractor Count</span>
          </h4>
          <div class="text-end-container">
            <button iconStart="@tui.x" class="margin-left-10" appearance="outline" tuiIconButton
            (click)="closeClearSubcontractorJob()" type="button" size="s" placement="right"></button>
          </div>
        </div>
      </div>
    </header>
    <div class="dialog-content">
      <hr class="title-line mt-1 mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <p class="text-center warning-color">
            <strong>Are you sure you want to clear?</strong>
          </p>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
          <button appearance="accent" tuiButton size="m" type="button" class="tui-space_bottom-3"
          (click)="clearSubcontractorJobCount()">Yes</button>
        </div>
      </div>
    </div>
  </tui-loader>
</ng-template>
